import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'nobamed',
} as IModuleProps;
